import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../../app/hooks";
import { getCoreUserFullName } from "../../../../common/utils/users";
import { selectCustomerUsersByCompanyId } from "../../customerUsersSlice";
import { StyledFormSection } from "../styles";
import LabelAutocompleteSelectRow from "./LabelAutocompleteSelectRow";

const CustomerContactsSection = () => {
  const { t } = useTranslation("customers");
  const params = useParams();
  const customerCompanyId = params.customerCompanyId || "";

  const customerUsersByCompanyId = useAppSelector(
    selectCustomerUsersByCompanyId(customerCompanyId),
  );

  const customerUserOptions = customerUsersByCompanyId.map((customerUser) => ({
    id: customerUser.id,
    name: getCoreUserFullName(customerUser),
  }));

  return (
    <StyledFormSection title={t("contract.customerContacts")}>
      <LabelAutocompleteSelectRow
        label={t("contract.contractResponsiblePerson")}
        fieldName="contractResponsiblePerson"
        customerCompanyId={customerCompanyId}
        options={customerUserOptions.sort((a, b) =>
          a.name.localeCompare(b.name),
        )}
      />
      <LabelAutocompleteSelectRow
        label={t("contract.invoicingResponsiblePerson")}
        fieldName="invoicingResponsiblePerson"
        customerCompanyId={customerCompanyId}
        options={customerUserOptions.sort((a, b) =>
          a.name.localeCompare(b.name),
        )}
      />
    </StyledFormSection>
  );
};

export default CustomerContactsSection;
